export default __webpack_public_path__ + "static/media/back_4.4fd6c981.jpg";